import ArticleTemplate from './ArticleTemplate';
import { allArticles } from './data';

export default function MainGuidePage() {
  return <ArticleTemplate article={allArticles[0]} />;
}